import script from "./AssessmentCards.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentCards.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentCards.vue?vue&type=style&index=0&id=4eab2ecd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eab2ecd"]])

export default __exports__